import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "gatsby-plugin-intl";

const Common_feature_box = ({featureImage, featureName, featureTC, bgColor}) => {

  let customColor = bgColor;

    return (
        <div className={"flex-1 rounded-t rounded-b-none overflow-hidden shadow-lg text-center px-6 py-2 " + customColor}>
          <div>
            {featureImage}
          </div>
          <div className="flex flex-col font-medium md:text-lg text-gray-600 mb-2">
            <div><FormattedMessage id={featureName} /></div>
            <div><small><FormattedMessage id={featureTC} /></small></div> 
          </div>
        </div>
    );
}

Common_feature_box.propTypes = {
    featureImage: PropTypes.string,
    featureName: PropTypes.string,
    featureTC: PropTypes.string,
    bgColor: PropTypes.string
};

export default Common_feature_box;